<section>
  <div class="terms row">
    <h1>Terms &amp; Conditions</h1>
    <div class="tnc_content">
      {{tnc}}
    </div>
    <hr class="lite" />
    <div class="text-right back-btn">
      <a href="/signup" class="btn btn-secondary">Back</a>
    </div>

  </div>
  
</section>